export default "__VITE_ASSET__C$ymKZWq__"